import "bootstrap/dist/css/bootstrap.min.css"

import "./src/styles/global.css"

require("prismjs/themes/prism-twilight.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("prismjs/plugins/command-line/prism-command-line.css")